import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api_url_v1 } from '../utils/config';

// Async thunk for admin login
export const loginAdmin = createAsyncThunk(
  'auth/loginAdmin',
  async ({ username, password }, { rejectWithValue }) => {
    const token = "SEnSES98"
    try {
      const response = await fetch(`${api_url_v1}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ username, pword:password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.message || 'Login failed');
      }

      const data = await response.json();
      
      // Hard-code the token as "becide"
      const responseWithToken = {
        ...data,
        token: "SEnSES98"
      };
      
      // Store token in localStorage
      localStorage.setItem('adminToken', responseWithToken.token);
      
      return responseWithToken;
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

// Initial state
const initialState = {
  admin: null,
  token: localStorage.getItem('adminToken') || null,
  isLoading: false,
  error: null,
  isAuthenticated: !!localStorage.getItem('adminToken'),
};

// Auth slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Clear error
    clearError: (state) => {
      state.error = null;
    },
    
    // Logout admin
    logoutAdmin: (state) => {
      state.admin = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      localStorage.removeItem('adminToken');
    },
    
    // Set admin from token (for app initialization)
    setAdminFromToken: (state, action) => {
      state.admin = action.payload;
      state.isAuthenticated = true;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login pending
      .addCase(loginAdmin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // Login fulfilled
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.admin = action.payload.admin;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        state.error = null;
      })
      // Login rejected
      .addCase(loginAdmin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
        state.admin = null;
        state.token = null;
      });
  },
});

// Export actions
export const { clearError, logoutAdmin, setAdminFromToken } = authSlice.actions;

// Export reducer
export default authSlice.reducer;

// Selectors
export const selectAuth = (state) => state?.auth;
export const selectIsAuthenticated = (state) => state.auth?.isAuthenticated;
export const selectAdmin = (state) => state.auth?.admin;
export const selectAuthError = (state) => state.auth?.error;
export const selectAuthLoading = (state) => state.auth?.isLoading;